<template>
  <div class="home_customerService">
    <div class="logo">
      <img :src="iconUrl" ref="imgRef" alt="logo" />
    </div>
    <p class="title" v-if="appName">{{ appName }}</p>
    <div class="buttons">
      <span class="btn download" @click="downloadApp">下载安卓App</span>
    </div>
    <div class="box-tips">
      <h5>安装小提示：</h5>
      <p>1.部分安卓机会弹窗引导下载，请注意点击<span>「下载」</span> <span>「更新」</span>类按钮正确安装</p>
      <p>2.如果您开启了<span>纯净模式</span> ，请先关闭后再安装。关闭流程：打开「设置」→ 「系统和更新」选项，找到<span>「纯净模式」</span>或 <span>「增强防护」</span> → 关闭开关（部分机型需输入锁屏密码确认）即可</p>
      <p>3.如果在安装时遇到<span>风险提示</span>，请点击「了解风险」，勾选<span>「已了解风险」</span>，即可继续安装。<span class="btn-view" @click="handleSetFlow(true)">查看</span></p>
      <p>4.若安装不成功，需卸载旧App后重新尝试安装</p>
    </div>
    <GuideOpen ref="guideOpen" />

    <div v-if="showFlow" class="box-flow" @click="handleSetFlow(false)">
      <img src="@/assets/images/guide-install.png" alt />
    </div>
  </div>
</template>

<script>
import GuideOpen from '@/components/GuideOpen.vue';
import { handleBuryPoint, isInWeixin } from '@/utils/tool.js'

const pageEvent = 'h5_suda_download';

export default{
  components: {
    GuideOpen
  },
  data() {
    return {
      iconUrl: 'https://cdn.longjudj.com/common/et3MN0IyBUs2Byb7nmTbM_sudaLogo.jpg',
      appName: '',
      downloadUrl: '',
      schema: '',
      showFlow: false,
    }
  },
  created() {
    handleBuryPoint(pageEvent, 'show');
  },
  methods: {
    handleSetFlow(show) {
      this.showFlow = show;
    },
    downloadApp() {
      if(isInWeixin()) {
        console.log('在微信里打开的，要引导哦')
        this.$refs.guideOpen && this.$refs.guideOpen.show();
      } else {
        this.canInstall()
      }
    },
    canInstall(url) {
      // APK文件的URL地址
      const apkUrl = 'https://priapp.yueyuechuxing.cn/client/packages/202603031015/sd_5.80.2.0052_20260303101519200.apk';
      // 点击立即安装成功按钮埋点
      handleBuryPoint(pageEvent, 'installImmediately_click', { url: apkUrl });
      // 创建隐藏的可下载链接
      const link = document.createElement('a');
      link.href = apkUrl;
      // 设置download属性（强制下载而不是打开）
      link.download = 'sd_5.80.2.0052.apk'; // 自定义下载文件名
      // 隐藏元素
      link.style.display = 'none';
      // 将链接添加到DOM
      document.body.appendChild(link);
      // 触发点击事件
      link.click();
      // 清理DOM
      document.body.removeChild(link);
    },
  }
}
</script>
<style lang="less" scoped>
.home_customerService {
  height: 100vh;
  background-color: #fff;
  position: relative;
  text-align: center;

  .logo {
    padding-top: 120px;

    img {
      width: 120px;
      height: 120px;
      border-radius: 12px;
    }
  }
  .title {
    font-family: PingFangSC-Medium;
    margin-top: 16px;
    font-size: 16px;
    color: #000;
  }
  .buttons {
    font-family: PingFangSC-Medium;
    letter-spacing: 0;
    font-size: 16px;
    margin-top: 40px;

    .btn {
      display: block;
      width: 200px;
      margin: 0 auto;
      border-radius: 12px;
    }
    .download {
      height: 52px;
      line-height: 52px;
      background-color: #0078fd;
      color: #fff;
    }
    .open {
      height: 50px;
      line-height: 50px;
      margin-top: 15px;
      background-color: #fff;
      color: #333;
      border: 1px solid #6b7886;
    }
  }
  .box-tips {
    margin-top: 40px;
    font-size: 14px;
    line-height: 1.5;
    padding: 0 24px;
    text-align: left;

    h5 {
      font-size: 16px;
      padding-left: 24px;
      background: url('https://cdn.longjudj.com/common/zTzXd8OCfcg1aWoc4RT1s_tips.png') no-repeat left center / 22px auto;
    }
    p {
      &:not(:last-child) {
        margin-bottom: 6px;
      }

      span {
        color: #f00;
        font-weight: bold;
      }

      .btn-view {
        color: #0078fd;
        font-weight: bold;
        cursor: pointer;
        border: 1px solid #0078fd;
        padding: 4px 12px;
        border-radius: 50px;
        font-size: 12px;
        margin-left: 6px;
      }
    }
  }
}
.box-flow {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.8);

  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
</style>